/**
 * 订单详情抽屉 - 客户信息区块
 *
 * 展示客户头像、姓名、公司名称与电话（可点击拨打）。受控组件，不持有业务状态。
 */
import React from 'react';
import type { OrderItem } from '../../../../../types';

interface Props {
  customer: OrderItem['customer'];
  /** 传入才给整块挂跳转；缺 id 时同样保持只读（对账时点空档案比不点更糟）。 */
  onOpenCustomer?: (customerId: string) => void;
}

export default function CustomerInfoSection({ customer, onOpenCustomer }: Props) {
  const customerId = customer?.id ?? '';
  const openable = Boolean(onOpenCustomer) && customerId.length > 0;

  const handleCall = (e: React.MouseEvent) => {
    // 拨号是卡里唯一的「跳出 App」动作，不能连带触发整块跳转
    e.stopPropagation();
  };

  return (
    <>
      {/* Customer info */}
      <div>
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">客户信息</p>
        <div
          onClick={openable ? () => onOpenCustomer?.(customerId) : undefined}
          className={`bg-gray-50 rounded-xl p-4 ${openable ? 'cursor-pointer hover:bg-gray-100 transition-colors' : ''}`}
        >
          {customer ? (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-teal-500 flex items-center justify-center shrink-0 text-white font-semibold overflow-hidden">
                {customer.avatar ? <img src={customer.avatar} alt="" className="w-full h-full object-cover" /> : (customer.fullName ?? '?').charAt(0).toUpperCase()}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-gray-900">{customer.fullName}</p>
                {customer.companyName && <p className="text-xs text-gray-400 mt-0.5">{customer.companyName}</p>}
                {customer.phone && <a href={`tel:${customer.phone}`} onClick={handleCall} className="text-xs text-teal-500 mt-0.5 hover:underline cursor-pointer">{customer.phone}</a>}
              </div>
              {openable && <span className="ml-auto shrink-0 self-start text-gray-300 text-lg leading-none" aria-hidden>›</span>}
            </div>
          ) : <p className="text-sm text-gray-400">暂无客户信息</p>}
        </div>
      </div>
    </>
  );
}